import { useRequiredContext } from "@redotech/react-util/context";
import CatalogIcon from "@redotech/redo-icons/catalog.svg";
import CatalogIconFilled from "@redotech/redo-icons/catalog_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { DEFAULT_CATALOG_VIEW } from "@redotech/redo-model/views/default-catalog-products-views";
import { LinkPrimaryTab } from "@redotech/redo-web/arbiter-components/navigation/primary/redo-primary-nav";
import { PageNavigationEntry } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { SecondaryNavigationData } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useLocation } from "react-router-dom";
import { CatalogViews } from "./catalog-products";

export function useCatalogNavigation(): PageNavigationEntry | null {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);

  const isCatalogEnabled =
    team.platform === "shopify" && (team.settings.ims?.catalogEnabled ?? false);

  if (!isCatalogEnabled) {
    return null;
  }

  const primaryTab: LinkPrimaryTab = {
    id: "catalog",
    hasNotification: false,
    UnfilledIcon: CatalogIcon,
    FilledIcon: CatalogIconFilled,
    type: "link",
    pathRoot: routes.catalogBaseUrl,
    href: `${routes.catalogProductsHref}/${DEFAULT_CATALOG_VIEW}`,
    friendlyName: "Catalog",
  };

  const secondaryNavigationData: SecondaryNavigationData = {
    id: "catalog",
    name: "Catalog",
    NavContent: CatalogSecondaryNavigation,
  };

  return { primaryTab, secondaryNavigationData };
}

const CatalogSecondaryNavigation = memo(function CatalogSecondaryNavigation() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const location = useLocation();

  const isProductsSelected =
    location.pathname.startsWith(`${routes.catalogProductsHref}/`) ||
    location.pathname === routes.catalogProductsHref;

  return (
    <>
      <RedoSecondaryNavItem
        action={{ type: "button" }}
        anyChildSelected={isProductsSelected}
        FilledIcon={CatalogIconFilled}
        friendlyName="Products"
        id="catalog-products"
        isFolder
        UnfilledIcon={CatalogIcon}
      >
        <CatalogViews />
      </RedoSecondaryNavItem>
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${routes.catalogBaseUrl}/consignment` }}
        friendlyName="Consignment"
        hidden={!(team._id === "68800d96229f8fc10f4dc1ce")}
        id="catalog-consignment"
      />
    </>
  );
});
